import React, { useState, useEffect, useRef} from 'react'
import { phoneViewer } from '../../assets'

function PhoneViewer({ URL })
{
    return(
        <div id="phoneViewer" style={{backgroundImage : `url(${URL})`}}>
            <img src={phoneViewer} alt="phoneViewer" />
        </div>
    );
}

function FeatsGrid({ items, curr, setCurr }) {
    return (
        <div id="featuresGrid" className="row">
            {items.map((v, k) => {
                return (<div className="col" key={k}>
                    <span key={k} className={k === curr ? "feat active" : "feat"}
                    onClick={() =>
                    {
                        const view = document.getElementById("features");
                        setCurr(k);
                        window.scrollTo(view.offsetLeft,view.offsetTop)
                    }}>
                        <span>
                            <img key={k} src={v.icon} alt={v.title}/>
                            <h6>{v.title}</h6>
                        </span>
                        <p title={v.description} >{v.description}</p>
                    </span>
                </div>);
            })}
        </div>
    );
}

function Features({ data }) {
    const [current, setCurrent] = useState(0);
    const interval = useRef();
    useEffect(() => {
        if (!isNaN(Number(data.carouselConf.time))
            && Number(data.carouselConf.time) > 0)
        {
            interval.current = setInterval(() => {
                if (current < (data.items.length - 1))
                    setCurrent(current + 1);
                else
                    setCurrent(0);
            }, (Number(data.carouselConf.time) * 1000));
            return () => clearInterval(interval.current);
        }
    }, [current]);
    return (
        <div id="features" className="container" >
            <h3>{ data.title }</h3>
            <div className="row">
                <div className="view col-xs-12 col-lg-4">
                    <PhoneViewer URL={data.items[current].screenshot} TITLE={data.items[current].title}/>
                </div>
                <div className="features col-xs-12 col-lg-8">
                    <FeatsGrid items={data.items} curr={current} setCurr={setCurrent}/>
                </div>
            </div>
        </div>
    )
}

export default Features
